import {useState} from "react";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {VIEW_TYPE} from "../../../../enums/ViewType";
import routes from "../../../../Routes/routes";
import {TABLES} from "../../../../Apis/Tables";
import {GUARD_ROSTER_PERMISSION} from "../Model/Model";

/**
 * Roster of the guards, as a table or as cards, searched by name, email, phone or zone access.
 * Keeps the state shared by both views, each view reads its own page of the roster. The search is
 * kept by the guards module, its header exports it and filters it.
 */
const GuardRosterApp = (props) => {
    const {setSelectedList, resetSearch} = props;

    const {t} = useTranslation();
    const navigate = useNavigate();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const {permission} = useSelector((state) => state.authenticatioauthennSlice);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const [view, setView] = useState(VIEW_TYPE.LIST.name);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const option = TABLES.GUARDS;

    const canUpdate = DEV || permission?.includes(GUARD_ROSTER_PERMISSION.UPDATE);
    const canDelete = DEV || permission?.includes(GUARD_ROSTER_PERMISSION.DELETE);
    const canCreate = DEV || permission?.includes(GUARD_ROSTER_PERMISSION.CREATE);

    const goUpdate = (item) => navigate(routes.guards.update + item?.userId);

    /**
     * Each view mounts its own search, so the selection and the search are cleared.
     */
    const handleView = (nextView) => {
        resetSearch();
        setIsAllChecked(false);
        setSelectedList([]);
        setView(nextView);
    };

    return {
        t,
        simpleSearch,
        setSimpleSearch,
        option,
        view,
        handleView,
        isAllChecked,
        setIsAllChecked,
        goUpdate,
        canUpdate,
        canDelete,
        canCreate,
    };
};

export default GuardRosterApp;
